/* istanbul ignore file */
import useRegions from '@/common/hooks/useRegions/useRegions'
import useFilters from '@/metrics/hooks/useFilters/useFilters'

import AlertsSection from './AlertsSection/AlertsSection'
import Header from './Header/Header'
import useViewType from './hooks/useViewType/useViewType'
import ReturnsMetricsContent from './ReturnsMetricsContent/ReturnsMetricsContent'
import ShipmentsMetricsContent from './ShipmentsMetricsContent/ShipmentsMetricsContent'
import ViewTypeSelector from './ViewTypeSelector/ViewTypeSelector'
import { dashboardViewTypes } from './constants'
import * as Styles from './styles'

const DashboardPage = ({ isUnifiedDashboard = false }) => {
  const { viewType, setViewType, showViewTypeSelector } = useViewType(isUnifiedDashboard)
  const { regions, loading: fetchingRegions } = useRegions()

  const filters = useFilters()

  return (
    <Styles.MainContainer>
      <Header
        regions={regions}
        commonFilters={filters.commonFilters}
        onChangeCommonFilter={filters.setCommonFilters}
        isUnifiedDashboard={isUnifiedDashboard}
      />
      <AlertsSection isUnifiedDashboard={isUnifiedDashboard} />
      <ViewTypeSelector viewType={viewType} onChangeViewType={setViewType} show={showViewTypeSelector} />
      {showViewTypeSelector && viewType === dashboardViewTypes.shipments ? (
        <ShipmentsMetricsContent
          commonFilters={filters.commonFilters}
          setCommonFilters={filters.setCommonFilters}
          regions={regions}
          fetchingRegions={fetchingRegions}
        />
      ) : (
        <ReturnsMetricsContent isUnifiedDashboard={isUnifiedDashboard} regions={regions} filters={filters} />
      )}
    </Styles.MainContainer>
  )
}

export default DashboardPage
